import saveBlobFile from "@benefit-systems/shared/utils/file/native";

import newRelicErrorReport from "web/utils/system/essentials/newRelicErrorReport";

import simpleApiRequest from "./simpleApiRequest";

export const getMimeType = (extension: string): string => {
  switch (true) {
    case ["png", "jpg", "jpeg"].includes(extension):
      return "image/*";
    case ["avi", "mp4", "mov"].includes(extension):
      return "video/*";
    case extension === "pdf":
      return "application/pdf";
    default:
      throw new Error(`Unsupported extension ${extension}`);
  }
};

const downloadFile = async (
  source: string,
  fileName: string,
  isApiSource = false,
  extension?: string,
  openInNewTab = false
) => {
  const extensionProcessed = extension ?? source?.split(".").pop();
  const fileNameParsed = fileName?.replace(".", "_");

  try {
    const response = await simpleApiRequest(source, {
      responseType: "arraybuffer",
    });
    const contentType = response.headers.get("content-type") || "";

    if (!response.ok) {
      throw new Error(`Download request failed with status ${response.status}`);
    }

    if (contentType.includes("application/json")) {
      throw new Error("Download request returned JSON response instead of file");
    }

    const mimeType =
      isApiSource && contentType
        ? contentType.split(";")[0]
        : getMimeType(extensionProcessed ?? "");

    const file = await response.arrayBuffer();
    const blob = new Blob([file], {
      type: mimeType,
    });

    await saveBlobFile({ blob, fileName: fileNameParsed, openInNewTab });
  } catch (error) {
    newRelicErrorReport(error, "web-app/web/api/downloadFile.js - 107");
    console.error(error);
    throw error;
  }
};

export default downloadFile;
